export default [
  {
    path: 'teachers',
    name: 'teachers',
    component: () => import('@/views/teacher/Teachers'),
    props: { role: 'teacher' },
    meta: {
      title: 'Giáo Viên',
      auth: true,
      permission: 'view-teacher-list',
    },
  },
  {
    path: 'teaching',
    name: 'teaching',
    component: () => import('@/views/teacher/Teaching'),
    props: { role: 'teacher' },
    meta: {
      title: 'Giảng dạy',
      auth: true,
      permission: 'view-teaching-list',
    },
  },
  {
    path: 'teacher/:id',
    name: 'teacher',
    component: () => import('@/views/teacher/Teacher'),
    meta: {
      title: 'Giáo viên',
      auth: true,
    },
  },
  {
    path: 'teacher-dashboard',
    name: 'TeacherDashboard',
    component: () => import('@/views/teacherSideViews/Dashboard'),
    meta: {
      title: 'Dashboard',
      auth: true,
    },
  },
  {
    path: 'ownClassTeacher',
    name: 'ownClassTeacher',
    component: () => import('@/views/teacher/OwnClassTeacher'),
    props: { role: 'teacher' },
    meta: {
      title: 'Chủ nhiệm',
      auth: true,
      permission: 'view-ownClass-list',
    },
  },
  {
    path: '/teacher-classes',
    name: 'TeacherClasses',
    component: () => import('@/views/teacher/Classes'),
    meta: {
      title: 'Danh Sách Lớp Của Tôi',
      auth: true,
    },
  },
  {
    path: '/teacher-attendance',
    name: 'TeacherAttendance',
    component: () => import('@/views/teacher/Attendances'),
    meta: {
      title: 'Điểm Danh Của Tôi',
      auth: true,
    },
  },
  {
    path: '/teachingDoc',
    component: () => import('@/views/teacherDocAdmin/teachingLevel.vue'),
    name: 'teachingDoc',
    meta: {
      title: 'Sổ sách',
      auth: true,
      // permission: ''
    },
  },
  {
    path: '/teachingDoc/:academicLevelId/teachingCat/',
    component: () => import('@/views/teacherDocAdmin/teachingCat.vue'),
    name: 'teachingCat',
    meta: {
      title: 'Đề cương, tài liệu',
      auth: true,
      // permission: ''
    },
  },
  {
    path: 'ownClassTimeTable',
    name: 'ownClassTimeTable',
    component: () => import('@/views/teacherSideViews/OwnClassTimeTable.vue'),
    meta: {
      title: 'Thời khóa biểu',
      auth: true,
    },
  },
  {
    path: 'teachingTimeTable',
    name: 'teachingTimeTable',
    component: () => import('@/views/teacherSideViews/TeachingTimeTable.vue'),
    meta: {
      title: 'Thời khóa biểu',
      auth: true,
    },
  },
  // ... các route khác liên quan đến teacher
]
